import { render, staticRenderFns } from "./RespostasAgrupadas.vue?vue&type=template&id=3cc5057a&scoped=true&"
import script from "./RespostasAgrupadas.vue?vue&type=script&lang=js&"
export * from "./RespostasAgrupadas.vue?vue&type=script&lang=js&"
import style0 from "./RespostasAgrupadas.vue?vue&type=style&index=0&id=3cc5057a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc5057a",
  null
  
)

export default component.exports